import { Component, inject } from '@angular/core';
import { OriginTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  OriginTypeCreateDto,
  OriginTypeDto,
  OriginTypeExcelDownloadDto,
  OriginTypeUpdateDto,
} from '../proxy/controlling/dtos/origin-type';
import { ORIGINTYPE_CONFIG, ORIGINTYPE_FIELDS } from './origin-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-origin-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, OriginTypeService, ConfirmationService],
  templateUrl: './origin-type.html',
  styleUrl: './origin-type.scss',
})
export class OriginType extends BaseCrudComponent<
  OriginTypeDto,
  OriginTypeCreateDto,
  OriginTypeUpdateDto,
  OriginTypeExcelDownloadDto
> {
  service = inject(OriginTypeService);
  config = ORIGINTYPE_CONFIG;
  fields = ORIGINTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: OriginTypeDto): OriginTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OriginType';
  }
}
